export const filterOptions = (
  userMap: Map<string, { email: string; name: string }>,
  inputValue: string,
) => {
  const filteredUsers = [];

  userMap.forEach((user, key) => {
    if (
      key.includes(inputValue.toLowerCase()) ||
      user?.email?.toLowerCase().includes(inputValue.toLowerCase()) ||
      user?.name?.toLowerCase().includes(inputValue.toLowerCase()) ||
      matchUserName(user?.name, inputValue)
    ) {
      filteredUsers.push(user);
    }
  });
  return filteredUsers;
};

/**
 * Checks if a user's full name matches a multi-word search term.
 *
 * @param {string} userName The full name string
 * @param {string} searchTerm The search string
 * @returns {boolean} True if all search tokens match at least one name token.
 */
function matchUserName(userName: string, searchTerm: string): boolean {
  if (!searchTerm) {
    return true;
  }

  const searchTokens = searchTerm
    .toLowerCase()
    .split(/\s+/)
    .filter((token) => token.length > 0);

  if (searchTokens.length === 0) {
    return true;
  }

  const nameTokens = (userName || '')
    .toLowerCase()
    .split(/\s+/)
    .filter((token) => token.length > 0);

  if (nameTokens.length === 0) {
    return false;
  }

  return searchTokens.every((sToken) => {
    return nameTokens.some((nToken) => nToken.includes(sToken));
  });
}

export const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};
